<template>
    <h1 class="text-center py-16 px-4 sm:px-6 lg:px-8 text-4xl font-extrabold tracking-tight text-gray-900">
        {{ $route.query.category ? decodeURIComponent($route.query.category) : 'Wszystkie produkty' }}
    </h1>
    <div v-if="$route.query.keywords">
        <p class="text-gray-400 text-center tracking-tight p-10">Wyniki wyszukiwania dla frazy: <span class="text-gray-900">{{ $route.query.keywords }}</span></p>
    </div>
    <Filters @changeFilters="changeFilters" @clearFilters="clearFilters" />
    <Products
        :category="$route.query.category || null"
        :type="$route.query.type || null"
        :priceFrom="$route.query.priceFrom || null"
        :priceTo="$route.query.priceTo || null"
        :department="$route.query.department || null"
        :keywords="$route.query.keywords || null"
        :sort="$route.query.sort || null"
        :showAvailable="$route.query.showAvailable || null"
        :withPhoto="$route.query.withPhoto || null"
    />
</template>
<script>
import Filters from "../components/sections/Filters.vue"
import Products from "../components/sections/Products.vue"

export default {
    name: "OfferPage",
    components: {
        Filters,
        Products,
    },
    methods: {
        changeFilters(filter, value) {
            const query = {};

            if (filter === 'category') query.category = value;
            else if (this.$route.query.category) query.category = decodeURIComponent(this.$route.query.category);

            if (filter === 'sort') query.sort = value;
            else if (this.$route.query.sort) query.sort = decodeURIComponent(this.$route.query.sort);

            if (filter === 'priceFrom') query.priceFrom = value;
            else if (this.$route.query.priceFrom) query.priceFrom = decodeURIComponent(this.$route.query.priceFrom);

            if (filter === 'priceTo') query.priceTo = value;
            else if (this.$route.query.priceTo) query.priceTo = decodeURIComponent(this.$route.query.priceTo);

            if (filter === 'department') query.department = value;
            else if (this.$route.query.department) query.department = decodeURIComponent(this.$route.query.department);

            if (filter === 'showAvailable') query.showAvailable = value;
            else if (this.$route.query.showAvailable) query.showAvailable = decodeURIComponent(this.$route.query.showAvailable);

            if (filter === 'withPhoto') query.withPhoto = value;
            else if (this.$route.query.withPhoto) query.withPhoto = decodeURIComponent(this.$route.query.withPhoto);

            if (filter === 'keywords') query.keywords = value;
            else if (this.$route.query.keywords) query.keywords = decodeURIComponent(this.$route.query.keywords);

            if (filter === 'type') query.type = value;
            else if (this.$route.query.type) query.type = decodeURIComponent(this.$route.query.type);

            this.$router.push({
                name: this.$route.name,
                query: {...query}
            });
        },
        clearFilters() {
            this.$router.push({
                name: this.$route.name
            })
        }
    }
}
</script>
